
import type { SummaryCall, SummaryAPIResponse, TranscriptItem } from "../types";

//const BASE_URL = "https://demo.aiguardian.io/agent-backend";
const BASE_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
const HEADERS = {
  "Content-Type": "application/json"  
};

export async function fetchSummary_o(token: string): Promise<{
  calls: SummaryCall[];
  today_calls: SummaryCall[];
  yesterday_calls: SummaryCall[];
  today_summary: string;
  yesterday_summary: string;
}> {
  const res = await fetch(`${BASE_URL}/api/summary`, {
    method: "GET",
    headers: {...HEADERS,  "Authorization": "Bearer "+token},
  });
  const json = await res.json();

  const today = json.today_calls || [];
  const yesterday = json.yesterday_calls || [];
  const all = [...today, ...yesterday];

  all.sort(
    (a, b) =>
      new Date(b.call_date_time.$date).getTime() -
      new Date(a.call_date_time.$date).getTime()
  );

  return {
    calls: all.slice(0, 100),
    today_calls: today,
    yesterday_calls: yesterday,
    today_summary: json.today_summary || {},
    yesterday_summary: json.yesterday_summary || {},
  };
}



export async function fetchSummary(token: string): Promise<{
  calls: SummaryCall[];
  summaryResp: SummaryAPIResponse;
}> {
  const url = `${BASE_URL}/api/summary`;
  //const res = await fetch(url, { method: "GET", headers: HEADERS });

  const res = await fetch(`${BASE_URL}/api/summary`, {
    method: "GET",
    headers: {...HEADERS,  "Authorization": "Bearer "+token},
  });

  if (!res.ok) {
    throw new Error(`fetchSummary failed: ${res.status}`);
  }
  const json: SummaryAPIResponse = await res.json();

  // 把不同时间段的 calls flatten 成一维数组
  const all: SummaryCall[] = Object.values(json.total_calls).flat();

  // 按 received_at 倒序
  all.sort(
    (a, b) =>
      new Date(b.received_at).getTime() - new Date(a.received_at).getTime()
  );

  return { calls: all, summaryResp: json };
}

export async function fetchPatient(patientId: string,token: string) {
  const res = await fetch(`${BASE_URL}/api/patient/${patientId}`, {
    method: "GET",
    headers: {...HEADERS,  "Authorization": "Bearer "+token},
  });
  const json = await res.json();
  return json.data;
}

export async function fetchTranscript(
  jobId: string,
  token: string
): Promise<{ transcript: TranscriptItem[]; summary: string }> {
  //const url = `${BASE_URL}/api/conversation/${jobId}`;
  ///const res = await fetch(url, { method: "GET", headers: HEADERS });
  const res = await fetch(`${BASE_URL}/api/conversation/${jobId}`, {
    method: "GET",
    headers: {...HEADERS,  "Authorization": "Bearer "+token},
  });

  if (!res.ok) {
    throw new Error(`fetchTranscript failed: ${res.status}`);
  }
  const json = await res.json();

  const data = json.data;
  if (!data) {
    console.warn("fetchTranscript: no data field in response");
    return { transcript: [], summary: "" };
  }

  // 后端把对话内容放在 data.transcript.items
  const items = Array.isArray(data.transcript?.items)
    ? data.transcript.items
    : [];

  // 转成 {q, a} 对
  const transcript: TranscriptItem[] = [];
  for (const it of items) {
    // content 也是数组
    const text =
      Array.isArray(it.content) && it.content.length > 0
        ? it.content[0]
        : "";

    if (it.role === "user") {
      transcript.push({ q: text, a: "" });
    } else if (it.role === "assistant") {
      // 把 assistant 的回答合到上一条 user 里
      const last = transcript[transcript.length - 1];
      if (last && !last.a) {
        last.a = text;
      } else {
        // 如果意外没有 q，就新开一条
        transcript.push({ q: "", a: text });
      }
    }
  }

  const summary: string =
    typeof data.summary === "string" ? data.summary : "";

  return { transcript, summary };
}

export async function fetchTranscript_a(jobId: string,token: string): Promise<{ q: string; a: string }[]> {
  const res = await fetch(`${BASE_URL}/api/conversation/${jobId}`, {
    method: "GET",
    headers: {...HEADERS,  "Authorization": "Bearer "+token},
  });
  const json = await res.json();
  const messages = json.data?.items || [];

  const qa: { q: string; a: string }[] = [];

  let lastAssistantMsg: string | null = null;

  for (const msg of messages) {
    const content = msg.content?.[0] || "";

    if (msg.role === "assistant") {
      lastAssistantMsg = content;
    } else if (msg.role === "user" && lastAssistantMsg !== null) {
      qa.push({ q: lastAssistantMsg, a: content });
      lastAssistantMsg = null;
    }
  }

  // 如果最后一个 assistant 发言没有 user 回复，也展示出来
  if (lastAssistantMsg !== null) {
    qa.push({ q: lastAssistantMsg, a: "" });
  }

  return qa;
}
